"use client"

import { Suspense } from "react"
import { ErrorBoundary } from "react-error-boundary"
import {
  NftActivityTableReatom,
  NftActivityTableSkeletonReatom,
} from "./activity-table.reatom"

export function NftActivityViewReatom() {
  return (
    <ErrorBoundary fallback={null}>
      <Suspense fallback={<NftActivityTableSkeletonReatom />}>
        <NftActivityTableReatom />
      </Suspense>
    </ErrorBoundary>
  )
}
